import { configureStore } from '@reduxjs/toolkit';
import partnerReducer from './partnerSlice';
import corporateReducer from './corporateSlice';
import gymReducer from './gymSlice';
import slotReducer from './slotSlice';
import revenueReducer from './revenueSlice';
import analyticsReducer from './analyticsSlice';
import corporateEmployeeReducer from './corporateEmployeeSlice';
import settingsReducer from './settingsSlice';
import supportReducer from './supportSlice';

export const store = configureStore({
  reducer: {
    partner: partnerReducer,
    corporate: corporateReducer,
    gym: gymReducer,
    slot: slotReducer,
    revenue: revenueReducer,
    analytics: analyticsReducer,
    corporateEmployee: corporateEmployeeReducer,
    settings: settingsReducer,
    support: supportReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
